module.exports = __webpack_public_path__ + "img/winter_ham.b27154fc.png";